<script>
    export default {
        name: "IsMine",
        data(){
            return {
                mineId: "",
                isMine: false,
            }
        },
        methods: {
            /**
             * 判断是否是“我自己”
             * @param otherId 要判断的id
             * @param callback 对比完成后回调
             */
            setUserId(otherId, callback = function () {}) {
                this.$im.getInfo(({id}) => {
                    this.mineId = id;
                    this.isMine = id === otherId;
                    callback(this.isMine);
                });
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/view/baseComponent/IsMine.vue